import bs58 from "bs58";

// Format checking is NOT on-chain mint verification or proof of issuer ownership.
export const isSolanaAddressFormatValid = (address) => {
  if (typeof address !== "string" || !/^[1-9A-HJ-NP-Za-km-z]{32,44}$/.test(address)) return false;
  try { return bs58.decode(address).length === 32; } catch { return false; }
};

export const validPlatformUrl = (value, domains) => {
  if (!value) return null;
  try {
    const url = new URL(value);
    const trustedHost = domains.some((domain) => url.hostname === domain || url.hostname.endsWith(`.${domain}`));
    return url.protocol === "https:" && trustedHost && !url.username && !url.password ? url.href : null;
  } catch { return null; }
};